export const getFilePathFromUrl = url => {
    return url.substr("/files/".length);
};
